(function () {
  const NOTE_LABEL = "Special Instructions";

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener("click", async (e) => {
    const editBtn = e.target.closest(".cart-line-note__edit");
    const saveBtn = e.target.closest(".cart-line-note__save");
    if (!editBtn && !saveBtn) return;

    const wrap = closest(e.target, ".cart-line-note");
    if (!wrap) return;

    const input = wrap.querySelector(".cart-line-note__input");
    const text = wrap.querySelector(".cart-line-note__text");
    const lineKey = wrap.getAttribute("data-line-key");

    // EDIT
    if (editBtn) {
      input.style.display = "block";
      input.focus();
      editBtn.style.display = "none";
      wrap.querySelector(".cart-line-note__save").style.display = "inline";
      return;
    }

    // SAVE
    if (saveBtn) {
      saveBtn.disabled = true;
      saveBtn.textContent = "Saving…";

      const value = (input.value || "").trim();

      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: lineKey,
          properties: {
            [NOTE_LABEL]: value || null
          }
        })
      });

      if (!res.ok) {
        saveBtn.disabled = false;
        saveBtn.textContent = "Save";
        alert("Could not save. Please try again.");
        return;
      }

      // Update UI
      text.textContent = value;
      input.style.display = "none";
      saveBtn.style.display = "none";
      saveBtn.disabled = false;
      saveBtn.textContent = "Save";
      wrap.querySelector(".cart-line-note__edit").style.display = "inline";
    }
  });
})();